import React from "react";
import { Link } from "react-router-dom";
import styles from "./index.module.css";

const Footer = () => (
  <footer className={styles.footer}>
    <div className={styles.inner}>
      <div className={styles.columns}>
        <div>
          <Link to="/home" className={styles.brand} aria-label="Riva home">
            <span className={styles.brandWheel} aria-hidden="true"><span className={styles.brandHub} /><span className={styles.brandSpoke} /></span>
            <span className={styles.brandWord}>RIVA</span>
            <span className={styles.brandDescriptor}>AUCTION HOUSE</span>
          </Link>
          <p className={styles.description}>Remarkable cars. Considered choices.<br />Discover your next drive with Riva.</p>
        </div>
        <nav aria-label="Footer explore">
          <h2>Explore</h2>
          <ul>
            <li><Link to="/auctions">The collection</Link></li>
            <li><Link to="/watchlist">Your watchlist</Link></li>
            <li><Link to="/about">About Riva</Link></li>
          </ul>
        </nav>
        <nav aria-label="Footer auctions">
          <h2>Your auctions</h2>
          <ul>
            <li><Link to="/buyer-dashboard">Buyer dashboard</Link></li>
            <li><Link to="/seller-dashboard">Seller studio</Link></li>
          </ul>
        </nav>
        <div className={styles.contact}>
          <h2>Project contact</h2>
          <a href="mailto:ashish@hexims.it?subject=PPH%20-%20RIVA">ashish@hexims.it</a>
          <span>Ref: PPH – RIVA</span>
        </div>
      </div>
      <div className={styles.bottom}>
        <span>© {new Date().getFullYear()} Riva Auction Concept</span>
        <span>Demonstration only · Bids and payments are simulated.</span>
      </div>
    </div>
  </footer>
);

export default Footer;
